import React, { useEffect } from "react";
import { useForm } from 'react-hook-form';

// components
import {
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    FormGroup,
    Input,
    Button,
    Spinner
} from "reactstrap";
import Select from 'react-select'

// style
import "../../../assets/css/loading.css";

// services
import { showMessage } from "../../../services/message.js";
import { api_POST, api_PUT } from "../../../services/api_service.js";
import { getSessionCookie } from "../../../services/session.js";

export default function ModalidadesColetaForm({ history, handleReturn, item }) {
    const session = getSessionCookie();

    const { register, handleSubmit, errors, setError, setValue, clearErrors } = useForm({ mode: "onBlur" });

    const [showLoading, setshowLoading] = React.useState(false);

    const options_status = [
        { value: 'Pendente', label: 'Pendente de Liberação' },
        { value: 'Ativo', label: 'Ativo' },
        { value: 'Inativo', label: 'Inativo' }
    ];

    const options_operacao = [
        { value: "Pontos de Coleta", label: "Pontos de Coleta" },
        { value: 'Execução de Serviço', label: 'Execução de Serviço' }
    ]

    const options_registroDestinacao = [
        { value: "Sim", label: "Sim" },
        { value: "Não", label: "Não" },
        { value: "Apenas Descarregamento", label: "Apenas Descarregamento" },
    ]

    const [operacao, setOperacao] = React.useState("");
    const handleOperacao = (value) => {
        setOperacao(value);
        clearErrors("operacao");
    }

    const [registroDestinacao, setRegistroDestinacao] = React.useState("");
    const handleRegistroDestinacao = (value) => {
        setRegistroDestinacao(value);
        clearErrors("registroDestinacao");
    }

    const [status, setStatus] = React.useState("");
    const handleStatus = (value) => {
        setStatus(value);
        clearErrors("status");
    }

    const [options_inconformidade, set_options_inconformidade] = React.useState([
        { tipo: 'Execução Fora da Sequência', descricao: 'Ex: Sequência de execução 3 executada antes das sequências 1 e 2', check: false },
        { tipo: 'Execução Não Realizada', descricao: 'Ex: Execução registrada como "Não Execução"', check: false },
        { tipo: "Registro de Ocorrência", descricao: "Ex: Realizou registro de ocorrência" },
        { tipo: 'Suspensão de OS', descricao: 'Ex: Ordem de Serviço Suspensa pelo Operador no Aplicativo', check: false },
        { tipo: 'Sem Leitura de GPS', descricao: 'Ex: Leitura registrada em 21/01/2021 10:00:00 com 30 minutos de atraso da última leitura registrada em 21/01/2021 09:30:00', check: false },
        { tipo: 'Execução Parcial Incompleta', descricao: 'Ex: Execução Parcial não concluída e justificativa de coleta obriga a executar tudo', check: false },
        { tipo: 'Tempo de sincronização excedido', descricao: 'Ex: A última sincronização do aplicativo ocorreu a 60 minutos (21/01/2021 09:30:00)', check: false },
        { tipo: 'Tempo de parada no mesmo local excedido', descricao: 'Ex: O tempo parado com o recurso em um lugar que não é um local de execução excedeu 10 minutos', check: false },
        { tipo: 'Tempo de parada no Local de Execução excedido', descricao: 'Ex: O tempo parado com o recurso no Local de Execução Rua 1, 123 - Bairro 1 após efetuar a execução excedeu o limite permitido.', check: false },
        { tipo: 'Não Realização de Registro do Comprovante de Destinação', descricao: 'Ex: Realizou a destinação mas não leu o QRCode do comprovante ou não tirou a foto.', check: false },
    ]);

    const handleOptionsInconformidade = (tipo, _check) => {
        let _options = [];
        options_inconformidade.map(m => {
            _options.push({ tipo: m.tipo, descricao: m.descricao, check: (m.tipo == tipo ? _check : m.check) })
        })
        set_options_inconformidade(_options);
    }

    const onSubmit = (data) => {

        if (status === "") {
            setError("status");
            return;
        }

        if (operacao === "") {
            setError("operacao");
            return;
        }

        if (registroDestinacao === "") {
            setError("registroDestinacao");
            return;
        }

        let inconformidades = [];
        options_inconformidade.filter(f => f.check == true).map(m => {
            inconformidades.push({ modalidadeColetaId: item == null ? 0 : item.modalidadeColetaId, tipoInconformidade: m.tipo })
        })

        let json_submit = {
            modalidadeColetaId: item == null ? 0 : item.modalidadeColetaId,
            descricao: data.descricao,
            status: status,
            usuarioCadastroId: session.usuarioId,
            usuarioAtualizacaoId: session.usuarioId,
            modalidadeColetaInconformidade: inconformidades,
            operacao: operacao,
            registraDestinacao: registroDestinacao
        }

        setshowLoading(true);
        if (json_submit.modalidadeColetaId == 0) {
            api_POST('modalidadecoleta', json_submit).then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error', null);
                }
                else {
                    showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                        handleReturn(result.data);
                    });
                }
            });
        }
        else {
            api_PUT('modalidadecoleta', json_submit).then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error', null);
                }
                else {
                    showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                        handleReturn(result.data);
                    });
                }
            });
        }
    };

    useEffect(() => {
        setValue("descricao", item == null ? "" : item.descricao);
        setStatus(item == null ? "" : item.status);
        setOperacao(item == null ? "" : item.operacao);
        setRegistroDestinacao(item == null ? "" : item.registraDestinacao);

        if (item != null) {
            let _options = [];
            options_inconformidade.map(m => {
                _options.push(
                    {
                        tipo: m.tipo,
                        descricao: m.descricao,
                        check: item.modalidadeColetaInconformidade.filter(f => f.tipoInconformidade == m.tipo).length > 0 ? true : false
                    }
                );
            })
            set_options_inconformidade(_options);
        }
    }, [item]);



    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <label style={{ marginRight: "20px" }}>Carregando...</label>
                        <Spinner size="sm" color="info" />
                    </div>
                </div>
            }
            <Row>
                <Container fluid>
                    <Card className="shadow">
                        <CardHeader className="border-0">
                            <strong> Cadastro de Modalidade de Serviço</strong>
                        </CardHeader>
                        <CardBody>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <Row>
                                    <Col md="6" lg="6">
                                        <FormGroup>
                                            <label className="form-control-label">
                                                * Descrição
                                            </label>
                                            <Input
                                                name="descricao"
                                                placeholder="Descrição"
                                                type="text"
                                                innerRef={register({ required: true })}
                                                maxLength={200}
                                            />
                                            {errors.descricao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" lg="3">
                                        <FormGroup>
                                            <label className="form-control-label">
                                                * Status
                                            </label>
                                            <Select
                                                options={options_status}
                                                name="status"
                                                onChange={(e) => { handleStatus(e.value) }}
                                                value={options_status.find(obj => obj.value === status)}
                                                placeholder="Selecione"
                                            />
                                            {errors.status && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" lg="3">
                                        <FormGroup>
                                            <label className="form-control-label">
                                                * Operação
                                            </label>
                                            <Select
                                                options={options_operacao}
                                                name="operacao"
                                                onChange={(e) => { handleOperacao(e.value) }}
                                                value={options_operacao.find(obj => obj.value === operacao)}
                                                placeholder="Selecione"
                                            />
                                            {errors.operacao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="4" lg="3" className="mt-2">
                                        <FormGroup >
                                            <label className="form-control-label">
                                                * Registrar Destinação?
                                            </label>
                                            <Select
                                                options={options_registroDestinacao}
                                                name="registroDestinacao"
                                                onChange={(e) => { handleRegistroDestinacao(e.value) }}
                                                value={options_registroDestinacao.find(obj => obj.value === registroDestinacao)}
                                                placeholder="Selecione"
                                            />
                                        </FormGroup>
                                        {errors.registroDestinacao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </Col>
                                    <Col md="12" lg="12" className="mt-1">
                                        <strong >
                                            Tipos de Alerta
                                        </strong>
                                    </Col>
                                    {options_inconformidade.map((item, key) => (
                                        <Col md="12" lg="12" key={key} className="pt-2">
                                            <FormGroup check>
                                                <label check className="form-control-label">
                                                    <Input
                                                        name={item.tipo}
                                                        type="checkbox"
                                                        onChange={(e) => handleOptionsInconformidade(item.tipo, e.target.checked)}
                                                        checked={item.check}
                                                        innerRef={register()}
                                                    />
                                                    {item.tipo} - <span style={{ fontWeight: 100 }}> {item.descricao}</span>
                                                </label>
                                            </FormGroup>
                                        </Col>
                                    ))
                                    }

                                </Row>
                                <Row>
                                    <Col md="12" className="text-center">
                                        <FormGroup>
                                            <Button color="warning" type="button" onClick={() => { handleReturn() }}>Voltar</Button>
                                            <Button color="success">Salvar</Button>
                                        </FormGroup>
                                    </Col>
                                </Row>

                            </form>
                        </CardBody>
                    </Card>
                </Container>
            </Row>
        </>
    );
}
